import React, { useEffect, useState } from "react";
import { Lightbulb } from "lucide-react";
import _ from "lodash";

const tips = [
  {
    title: "Foto's zijn belangrijk",
    text: "Het is een understatement om te zeggen dat goede foto's van je ruimte belangrijk zijn. Foto's zijn het allereerste waar mensen naar kijken als ze een locatie zoeken.",
  },
  {
    title: "Laat de binnenkant stralen",
    text: "Goed licht is de beste vriend van elke fotograaf. Het benadrukt de natuurlijke diepte, kleur en contrast van een ruimte.",
  },
  {
    title: "Benadruk unieke kenmerken",
    text: "Heeft uw locatie een mooi terras? Een geweldige keuken? Of een adembenemend uitzicht? Laat het weten met foto's.",
  },
  {
    title: "Neem foto's buiten",
    text: "De beste tijd om buiten te fotograferen is het eerste uur na zonsopgang of voor zonsondergang, ook wel bekend als het 'Gouden Uur'.",
  },
  {
    title: "Fotografeer de hoeken",
    text: "Deze techniek zorgt ervoor dat je ruimte groter lijkt en zorgt voor meer dimensie in je foto.",
  },
];

function Tips() {
  const [index, setIndex] = useState(_.random(0, tips.length - 1));

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev === tips.length - 1 ? 0 : prev + 1));
    }, 12000);
    return () => clearInterval(timer);
  }, []);

  const tip = tips[index];

  return (
    <div className="flex items-start gap-3 p-4 bg-info-subtle border border-info/10 rounded-sm">
      <Lightbulb size={18} strokeWidth={1.5} className="text-info shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-medium text-text-primary mb-1">{tip.title}</p>
        <p className="text-sm text-text-secondary leading-relaxed">{tip.text}</p>
      </div>
    </div>
  );
}

export default Tips;
